module.exports = __webpack_public_path__ + "static/img/starter.2c1f1564.svg";